import { WorkType } from "../CommonProps";
import { JobEstimationDetail } from "../modals/JobEstimationDetail";
import moment from "moment";

export interface PredictedWorkTimeline {
  date: any;
  days: number;
}

export class CommonMethodService {
  getDataFromStorage(key: string) {
    const data = localStorage.getItem(key);
    if (data) {
      return JSON.parse(data);
    } else {
      return null;
    }
  }

  getAdminHeaderText(estimateData: JobEstimationDetail | null, allowNull = false) {
    let userName = "";
    if (!estimateData || !estimateData.ownerName) return allowNull ? null : "N/A";
    if (estimateData?.ownerName) {
      userName = estimateData?.ownerName;
    }
    return `You're logged in as ${userName}`;
  }

  isValidEmail = (email: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  isValidPhone = (phone: string): boolean => {
    const phoneRegex = /^[\d\s\-\+\(\)]{8,}$/;
    return phoneRegex.test(phone.trim());
  };

  isValidOTP = (otp: string): boolean => {
    return otp.length == 6;
  };

  setDataIntoStorage(key: string, object: any) {
    localStorage.setItem(key, JSON.stringify(object));
  }

  deleteDataFromStorage(key: string) {
    localStorage.removeItem(key);
  }

  static params(lowercase = true) {
    const urlSearchParams = new URLSearchParams(
      lowercase ? window.location.search.toLowerCase() : window.location.search
    );
    return Object.fromEntries(urlSearchParams.entries());
  }

  setQueryParams(estimateId: number | string, step: string, status?: string) {
    const searchParams = new URLSearchParams(window.location.search);
    if (estimateId !== 0) {
      searchParams.set("estimateid", estimateId.toString());
    }
    if (status) {
      searchParams.set("status", status.toString());
    }
    searchParams.set("step", step);
    const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
    window.history.replaceState({}, "", newUrl);
  }

  removeSingleQueryParams(type: string) {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.delete(type);
    const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
    window.history.replaceState({}, "", newUrl);
  }

  removeAllQueryParams() {
    const newUrl = window.location.pathname;
    window.history.replaceState({}, "", newUrl);
  }

  createNotificationTemplate(
    estimateDetails: JobEstimationDetail,
    type: string,
    expectedArrival?: string,
    canceledReason?: string
  ) {
    const typeOfNotification =
      type === "cancel"
        ? "Canceled Job Booking"
        : type === "revise"
        ? "Revised Job Booking"
        : type === "accepted"
        ? "Estimate Accepted"
        : type === "declined"
        ? "Estimate Declined"
        : "Job Booking";
    let htmlContent = `<p>
    <strong ${
      type === "cancel" || type === "declined"
        ? `style='color:#FF0000'`
        : type === "revise" || type === "accepted"
        ? `style='color:#30824e'`
        : ``
    }>${typeOfNotification}</strong> ${
      estimateDetails.estimateNumber ? estimateDetails.estimateNumber : ""
    }
    <br>
    <strong>Customer:</strong> ${
      estimateDetails?.ownerName ? estimateDetails?.ownerName : ""
    }
    <br>
    <strong>Email:</strong> ${
      estimateDetails?.email ? estimateDetails?.email : ""
    }
    <br>
    <strong>Contact:</strong> ${
      estimateDetails?.mobilePhone ? estimateDetails?.mobilePhone : ""
    }
    <br>
    ${
      type === "cancel" || type === "accepted" || type === "declined"
        ? ` <strong> ${typeOfNotification} Date:</strong> ${moment(
            new Date()
          ).format("YYYY-MM-DD HH:mm A")}`
        : ` <strong>Booking Date:</strong> ${expectedArrival}`
    }
    <br>
    ${
      type !== "cancel"
        ? `<strong>Workflow:</strong> <a href="https://app.flowautobody.com/#/planner/booking-calendar">link</a> 
        <br>`
        : ""
    }

    <strong>IBS:</strong> <a href="https://app.ibodyshop.com/#/Estimate/${
      estimateDetails.estimateId
    }/header">link</a>
    <br>
    ${type === "cancel" ? `<strong>Reason:</strong> ${canceledReason}` : ``}
  </p>`;
    return htmlContent;
  }

  getPredictingWorkDate(
    date: string,
    numberOfDays: number
  ): PredictedWorkTimeline {
    if (date) {
      let currentDate = moment(date);
      let remainingWorkingDays = numberOfDays;
      let days = 0;
      while (remainingWorkingDays > 0) {
        currentDate = currentDate.add(1, "day");
        if (currentDate.day() >= 1 && currentDate.day() <= 5) {
          remainingWorkingDays--;
        }
        days++;
      }

      return { date: currentDate.format("YYYY-MM-DDTHH:mm"), days };
    } else {
      return { date: "", days: 0 };
    }
  }

  getWorkType(value: number) {
    if ((value > 1000 && value <= 2500) || value === 0) {
      return WorkType.MEDIUM;
    }
    if (value > 2500) {
      return WorkType.LARGE;
    }
    return WorkType.SMALL;
  }
}
